<template>
  <article class="d-flex justify-content-center w-100 h-100 min-vh-100 px-sm-2 px-xxs-0 py-sm-3
    pt-xxs-5 pb-xxs-0 align-items-sm-center">
    <section class="border-md d-flex flex-column col-lg-5 col-sm-7 col-xxs-12 p-sm-5 p-xxs-4 mt-md-5 text-dark bg-white">
      <h3 class="text-danger mt-sm-0 mt-4 mb-5 px-sm-2 px-xs-1">
        <i class="icon-phone"></i>
      {{ $t('ContactUs.title')}}
      </h3>
      <div  v-show="!showSuccessfullMessage">
        <div role="group" class="col-xxs-12 p-0">
          <label for="inputLive">
            {{ $t('ContactUs.fullName') }}
          </label>
          <b-form-input
            id="inputLive"
            v-model.trim="name"
            type="text"
            :placeholder="$t('ContactUs.fullNamePlaceholder')"
          />
        </div>
        <div role="group" class="col-xxs-12 p-0 mt-3">
          <label for="inputLive">
            {{ $t('ContactUs.emailOrTel') }}
          </label>
          <b-form-input
            id="emailOrTel"
            v-model.trim="email"
            class="dir-ltr"
            type="text"
            placeholder="you@example.com"
          />
        </div>
        <div role="group" class="col-xxs-12 p-0 mt-3">
          <label for="inputLive">
            {{ $t('ContactUs.subject') }}
          </label>
          <b-form-input
            id="subject"
            type="text"
            v-model.trim="subject"
            :placeholder="$t('ContactUs.subjectPlaceholder')"
          />
        </div>
        <div role="group" class="mt-3">
          <label for="inputLive">
            {{ $t('ContactUs.message') }}
          </label>
          <b-form-textarea
            id="message"
            v-model.trim="message"
            :rows="5"
            :max-rows="15"
          />
        </div>
        <b-alert
          v-show="showFailureMessage"
          show
          fade
          class="mt-3"
          variant="danger"
        >
            {{ $t('ContactUs.sendFailureMessage') }}
        </b-alert>
          <b-button class="mt-3" :disabled="buttonDisable" :variant="buttonVariant" block @click="send">
            {{ $t('ContactUs.sendMessage') }}
        </b-button>
      </div>
      <b-alert
        v-show="showSuccessfullMessage"
        show
        fade
        class="mx-md-5 mx-sm-3 mx-xs-1"
        variant="success"
      >
          {{ $t('ContactUs.sendSuccessfull') }}
      </b-alert>
    </section>
  </article>
</template>

<script>
import Vue from 'vue'
import { mapActions } from 'vuex'

export default Vue.extend({
  name: 'ContactUsIndependent',
  data () {
    return {
      showFailureMessage: false,
      showSuccessfullMessage: false,
      name: '',
      email: '',
      subject: '',
      message: ''
    }
  },
  computed: {
    nameState () {
      return this.message.length > 5
    },
    buttonDisable() {
      return !this.nameState || this.name.length === 0 
        || this.email.length === 0 || this.subject.length === 0
    },
    buttonVariant() {
      return this.buttonDisable ? 'outline-dark' : 'primary' 
    } 
  },
  methods: {
    ...mapActions({
      sendContactUs: 'contactUs/send'
    }),
    send () {
      let input = {
        name: this.name,
        email: this.email,
        subject: this.subject,
        message: this.message
      }

      this.sendContactUs(input).then((response) => {
        this.showSuccessfullMessage = true
        this.$ga.event('Misc', 'ContactUs')
      }).catch((response) => {
        this.showFailureMessage = true

        setTimeout(() => {
          this.showFailureMessage = false
        }, 3000)
      })
    }
  }
})
</script>
